module.exports = __webpack_public_path__ + "img/profiles@2x.467ed31.webp";